import {
  AvailableCouponDto,
  AvailableCouponDtoRedeemStatusEnum,
} from '../../../generated/api';
import { assertNever } from '../../../utils/typeHelper';
import { UniversalRedeemableCoupon } from '../../models/coupon';
import { couponItemToUniversalCoupon } from '../couponItemToUniversalCoupon';

export function availableCouponDtoToUniversalRedeemableCoupon(
  dto: AvailableCouponDto,
): null | UniversalRedeemableCoupon {
  const coupon = couponItemToUniversalCoupon(dto.coupon);
  if (!coupon) return null;
  switch (dto.redeemStatus) {
    case AvailableCouponDtoRedeemStatusEnum.Nonredeemable:
      return {
        status: UniversalRedeemableCoupon.Status.Nonredeemable,
        couponId: dto.couponId,
        coupon,
        reason: dto.reason ?? '',
      };
    case AvailableCouponDtoRedeemStatusEnum.Redeemable:
      return {
        status: UniversalRedeemableCoupon.Status.Redeemable,
        couponId: dto.couponId,
        coupon,
      };
    case AvailableCouponDtoRedeemStatusEnum.Redeemed:
      return {
        status: UniversalRedeemableCoupon.Status.Redeemed,
        couponId: dto.couponId,
        coupon,
        redeemedCouponId: dto.redeemedCouponId!,
      };
    default:
      assertNever(dto.redeemStatus);
  }
}
